import React from "react";
import SmallTextFormSimple from "./SmallTextFormSimple";
import LargeTextFormSimple from "./LargeTextFormSimple";
import CheckboxFormSimple from "./CheckboxFormSimple";
import DropdownFormSimple from "./DropdownFormSimple";
import RadioFormSimple from "./RadioFormSimple";
import CheckboxListFormSimple from "./CheckboxListFormSimple";

const OrderFormFieldViewSimple = ({
  formikProps,
  orderFormField,
  ticket,
  index,
}) => {
  const { name, nameForTicket, required, type, options } = orderFormField;

  let nameText = ticket && nameForTicket ? nameForTicket : name;
  nameText = required ? `${nameText} *` : nameText;
  const orderFormFieldKey = "editingOrderForm";
  const { values, touched, errors, handleChange, handleBlur, setFieldValue } =
    formikProps;
  let value;
  if (values) {
    value = values[orderFormFieldKey] || "";
  } else {
    value = "";
  }

  const orderFormFieldTouched = touched[orderFormFieldKey];
  const orderFormFieldError = errors[orderFormFieldKey];

  switch (type) {
    case "smallText":
      return (
        <SmallTextFormSimple
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            value,
            handleChange,
            handleBlur,
          }}
        />
      );
    case "largeText":
      return (
        <LargeTextFormSimple
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            value,
            handleChange,
            handleBlur,
          }}
        />
      );
    case "checkbox":
      return (
        <CheckboxFormSimple
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            nameText,
            value,
            setFieldValue,
            handleBlur,
          }}
        />
      );
    case "multiSelectDropdown":
      return (
        <DropdownFormSimple
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            value,
            options,
            handleChange,
            handleBlur,
          }}
        />
      );
    case "multiSelectRadio":
      return (
        <RadioFormSimple
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            value,
            options,
            handleChange,
            handleBlur,
          }}
        />
      );
    case "multiSelectCheckbox":
      return (
        <CheckboxListFormSimple
          {...{
            orderFormFieldKey,
            orderFormFieldTouched,
            orderFormFieldError,
            value,
            options,
            setFieldValue,
            handleBlur,
          }}
        />
      );
    default:
      return null;
  }
};

export default OrderFormFieldViewSimple;
